import React from 'react';

import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';

import type { NameSwitcherProps as Props } from './types';
import styles from './nameSwitcher.module.css';

const NameSwicther = ({ onSwitch, onClose }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.nameContainer}>
        <div className={styles.name}>
          {t('checkout.touristForm.name.title')}
        </div>
        &nbsp; ↔ &nbsp;
        <div className={styles.name}>
          {t('checkout.touristForm.surname.title')}
        </div>
      </div>
      <div className={styles.hint}>{t('checkout.touristForm.switcher')}</div>
      <div className={styles.buttonContainer}>
        <Button
          className={styles.button}
          size="none"
          primary
          onClick={onSwitch}
        >
          {t('checkout.touristForm.change')}
        </Button>
        <Button className={styles.button} size="none" onClick={onClose}>
          {t('filters.panel.cancel')}
        </Button>
      </div>
    </div>
  );
};

export default NameSwicther;
